// Check if object is empty
function isEmpty(obj) {
  if (!obj) return false;
  return Object.keys(obj).length === 0;
}

export default isEmpty;
